/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not save the space." |
*
* @param {External_Apis_Space_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_save_error = /** @type {((inputs?: External_Apis_Space_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Space konnte nicht gespeichert werden.")
	return /** @type {LocalizedString} */ ("Could not save the space.")
});